module.exports = __webpack_public_path__ + "static/media/burnout.8db0f77b.jpg";